import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Helpers } from 'projects/training-calendar/src/app/helpers';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.css']
})
export class ImageSliderComponent implements OnInit {
	@Input() imageUrls = [];
	@Input() showSlider = false;
	@Input() activeSlideIndex = 0;
	helpers = Helpers;
	@Output() showSliderChange = new EventEmitter();
	@Input() photoUploadedBy = [];
	docUploadedBy: any;
	imageUrlsFirst:any="";
	constructor(
  ) { }

	ngOnInit() {
		if(this.imageUrls && this.imageUrls.length){
			this.imageUrlsFirst = this.imageUrls[0];
		}
		if ((this.imageUrls && this.imageUrls.length !== 0) && (this.photoUploadedBy && this.photoUploadedBy.length !== 0)) {
			this.docUploadedBy = this.photoUploadedBy[this.activeSlideIndex];
		}
		console.log(this.imageUrls,this.docUploadedBy);
  	}

	closeModal() {
		this.showSliderChange.emit(false);
	}

	onNext() {
		if (this.activeSlideIndex === (this.imageUrls.length - 1)) {
			this.activeSlideIndex = 0;
		} else {
			this.activeSlideIndex++;
		}
		if ((this.imageUrls && this.imageUrls.length !== 0) && (this.photoUploadedBy && this.photoUploadedBy.length !== 0)) {
			this.docUploadedBy = this.photoUploadedBy[this.activeSlideIndex];
		}
		console.log('on Next')
	}

	onPrevious() {
		// this.activeSlideIndex--;
		if (this.activeSlideIndex === 0) {
			this.activeSlideIndex = this.imageUrls.length - 1;
		} else {
			this.activeSlideIndex--;
		}
		if ((this.imageUrls && this.imageUrls.length !== 0) && (this.photoUploadedBy && this.photoUploadedBy.length !== 0)) {
			this.docUploadedBy = this.photoUploadedBy[this.activeSlideIndex];
		}
		console.log('on Previous')
	}

}